import { render, staticRenderFns } from "./LatentDangerList.vue?vue&type=template&id=73882a75&scoped=true&"
import script from "./LatentDangerList.vue?vue&type=script&lang=js&"
export * from "./LatentDangerList.vue?vue&type=script&lang=js&"
import style0 from "./LatentDangerList.vue?vue&type=style&index=0&id=73882a75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73882a75",
  null
  
)

export default component.exports